// extracted by mini-css-extract-plugin
export default {"root":"swap-list_root__oPqpE"};